import React, { useState, useEffect, useRef } from "react";
import { useGetWordsQuery } from "../rtk/words";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, FormControlLabel, Grid, LinearProgress, Paper, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Check, ChevronRight, ExpandMore } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { useGetImportancesQuery } from "../rtk/importance";
import { useGetValuesQuery, useGetWordscoresQuery, useSubmitFirstStepMutation, useSubmitSecondStepMutation, useSubmitThirdStepMutation } from "../rtk/form";

const ThirdStep = (props) => {
    const { t } = useTranslation()
    const user = useSelector((state) => state.user.user)

    const [isInstructions, setIsInstructions] = useState(true)

    const [results, setResults] = useState([])

    const { data: values } = useGetValuesQuery();
    const { data: scores } = useGetWordscoresQuery();
    const { data: words } = useGetWordsQuery();

    const theme = useTheme()

    const [open, setOpen] = useState([true,false,false,false]);

    const [submit, response] = useSubmitThirdStepMutation()


    const [bestWords, setBestWords] = useState([])

    useEffect(() => {
        if (!!!isInstructions) {
            props.setIsRunning(true)
        }
        else {
            props.setIsRunning(false)
        }
    }, [isInstructions])
    
    useEffect(() => {
        if (scores) {
            getBestWords()
        }
    }, [scores])

    useEffect(() => {
        //Open next accordion if not already open and 4 results in previous accordion
        // Count number of results in previous accordion
        for(let i=0; i<3; i++){
            if(results.filter((result) => result.value === values[i].id).length === 4 && !open[i+1] && results.filter((result) => result.value === values[i+1].id).length === 0){
                setOpen((prev) => {
                    const temp = [...prev]
                    temp[i+1] = true
                    temp[i] = false
                    return temp
                })
            }
        }
    }, [results])
            

    const getBestWords = () => {
        const categories = [6, 5, 4, 3, 2, 1, 0]
        let temp_bestwords = []
        while (temp_bestwords.length < 20) {
            for (let i = 0; i < categories.length; i++) {
                const category = categories[i]
                const wordsInCategory = scores.filter((word) => word.importance === category)
                if (wordsInCategory.length > 0) {
                    temp_bestwords = [...temp_bestwords, ...wordsInCategory.map((word) => word.word)]
                }
                if (temp_bestwords.length >= 20) {
                    break
                }
            }
        }
        setBestWords(temp_bestwords)
    }

    const renderInstructions = () => {
        return (
            <Stack sx={{ p: 2 }} spacing={2}>
                <Typography variant="h4">{t("third_step_title")}</Typography>
                <Typography variant="body1" textAlign={"justify"}>{t("third_step_text")}</Typography>
                <Typography variant="body1" textAlign={"justify"}>{t("stop_message")}</Typography>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Button variant="outlined" onClick={props.logoff}>{t("stop")}</Button>
                    <Button variant="contained" onClick={() => setIsInstructions(false)} endIcon={<ChevronRight />}>{t("start")}</Button>
                </Box>
            </Stack>
        )
    }

    const handleResultClick = (word, value) => {
        const temp_results = [...results]
        const index = temp_results.findIndex((el) => el.word === word && el.value === value)
        if (index !== -1) {
            temp_results.splice(index, 1)
        } else {
            temp_results.push({ word: word, value: value })
        }
        setResults(temp_results)
    }

    const getWordInLanguage = (word) => {
        const wordInLanguage = words.find((w) => w.id === word)
        if (!wordInLanguage) return ("")
        if (user.language === "en") {
            return wordInLanguage.word_en
        } else if (user.language === "sp") {
            return wordInLanguage.word_sp
        }
        else {
            return wordInLanguage.word_fr
        }
    }

    const handleSubmit = () => {
        submit(results)
    }

    const isStepCompleted = () => {
        return results.length === 16
    }

    const getIsButtonDisabled = (word, value) => {
        return (results.findIndex((el) => el.word === word) !== -1 && results.findIndex((el) => el.value === value && el.word === word) === -1) || (results.filter(el => el.value === value).length >= 4 && results.findIndex((el) => el.value === value && el.word === word) === -1) || values.findIndex((el) => el.word === word) !== -1
    }

    const getButtonIsSelected = (word, value) => {
        return results.findIndex((el) => el.value === value && el.word === word) !== -1
    }

    const renderStep = () => {
        // Chose 4 words from the best words for each value
        return (
            <Stack sx={{ p: 2 }} spacing={2}>
                <Typography variant="h4">{t("third_step_title")}</Typography>
                <Typography variant="body1">{t("third_step_recap_instruction")}</Typography>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Stack sx={{ width: "100%" }} >
                        {values.map((value,i) => {
                            return (
                                <Accordion key={value.id} sx={{ p: 0 }} expanded={open[i]} onChange={()=> {
                                    setOpen(open.map((el,j) => {
                                        if (i===j) {
                                            return !el
                                        } else {
                                            return el
                                        }
                                    }
                                    ))
                                }}>
                                    <AccordionSummary expandIcon={<ExpandMore />}>
                                        <span>
                                            <Typography component={"span"} variant="h5">{t('third_step_for_your_value')} </Typography>
                                            <Typography component={"span"} sx={{fontWeight:"bold", color:theme.palette.primary.main}} variant="h5">{getWordInLanguage(value.word)}</Typography>

                                        </span>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                            <Grid container spacing={2}>
                                                {bestWords.map((word) => {
                                                    return (
                                                        <Grid item xs={6} md={3} key={word}>
                                                            <Button
                                                                fullWidth
                                                                variant={getButtonIsSelected(word, value.id) ? "contained" : "outlined"}
                                                                disabled={getIsButtonDisabled(word, value.id)}
                                                                onClick={() => handleResultClick(word, value.id)}
                                                                endIcon={getButtonIsSelected(word, value.id) ? <Check /> : null}
                                                            >{getWordInLanguage(word)}</Button>
                                                        </Grid>
                                                    )
                                                }
                                                )}
                                            </Grid>
                                    </AccordionDetails>
                                </Accordion>
                            )
                        })}
                    </Stack>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Button variant="contained" disabled={!isStepCompleted()} onClick={handleSubmit} endIcon={<ChevronRight />}>{t("next")}</Button>
                </Box>
            </Stack>
        )
    }

    return (
        <Stack>
            {
                isInstructions ? renderInstructions()
                    : renderStep()
            }
        </Stack>
    )
}
export default ThirdStep